import React from "react";

const RolesSelect = props => (
  <select {...props}>
    <option />
    {props.roles.map((role, key) => (
      <option value={role.id} key={key}>
        {role.name}
      </option>
    ))}
  </select>
);

export default RolesSelect;



// WEBPACK FOOTER //
// ./src/containers/UserPage/RolesSelect.js